module.exports = __webpack_public_path__ + "img/bulletDocumentsAlianzas.b71dc22d.svg";